import reels from './reels.png';
import tiktok from './tiktok.png';
import showdown from './showdown.png';
import case_study from './case_study.png';
import howtouse from './howtouse.png';
import conclusion from './conclusion.png';

export const blogImages = {
  reels,
  tiktok,
  showdown,
  case_study,
  howtouse,
  conclusion
}; 